import { EventRequest, EventState } from 'types';
import { DEFAULT_CURRENCY } from '@utils/currency';

interface CreateEventStateParams {
  // Not derived from the request: it is read from LaunchDarkly once at load, so a rebuild carries it over.
  paginationEnabled?: boolean;
  request: EventRequest;
}

export const createEventState = ({ paginationEnabled = false, request }: CreateEventStateParams): EventState => {
  const hasActiveBids = Boolean(request?.active_bids);
  const supplierOrganizations = request?.vendor_organizations || [];
  const hasSuppliers = Boolean(supplierOrganizations?.length);
  const hasInvitedOrScheduledSuppliers = Boolean(request?.has_invited_or_scheduled_suppliers);
  const eventIncumbentId = request?.overall_incumbent_id;
  const hasLineItems = paginationEnabled
    ? Boolean(request?.lots?.some(lot => lot.line_items_count > 0))
    : Boolean(request?.lots?.some(lot => lot.line_items?.length));
  const isReadOnly = hasLineItems && hasActiveBids;
  const currency = request?.currency || DEFAULT_CURRENCY;
  const {
    collect_items_per_unit: collectItemsPerUnit = false,
    show_pricing_columns: showPricingColumns = false,
    set_baseline_average_on_first_round_quotes: setBaselineAverage = false,
    show_discount: showDiscount = false,
    show_extended_price_feedback: showExtendedPriceFeedback = true,
    show_logistics_charge: showLogisticsCharge = false,
  } = request?.ui_config?.lots || {};

  return {
    collectItemsPerUnit,
    currency,
    eventIncumbentId,
    hasInvitedOrScheduledSuppliers,
    hasSuppliers,
    isReadOnly,
    originalCurrency: currency,
    originalEventIncumbentId: eventIncumbentId,
    paginationEnabled,
    requestType: request?.request_type,
    setBaselineAverage,
    showDiscount,
    showExtendedPriceFeedback,
    showLogisticsCharge,
    showPricingColumns,
    supplierOrganizations,
  };
};
